(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function initNativeDrawerShipping() {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer || drawer.dataset.shippingProgressReady === 'true') return;
      var panel = drawer.querySelector('[data-cart-drawer-shipping-progress]');
      if (!panel) return;
      drawer.dataset.shippingProgressReady = 'true';
      var country = panel.dataset.country;
      var copy = panel.querySelector('[data-cart-drawer-shipping-copy]');
      var meter = panel.querySelector('.ccp-cart-drawer__shipping-meter');
      var giftToggle = drawer.querySelector('[data-cart-gift-toggle]');
      var giftMessage = drawer.querySelector('#CartNoteDrawer');
      var timer;
      var removing = false;
      var removalError = drawer.querySelector('[data-cart-drawer-error]');
      var removalStatus = drawer.querySelector('[data-cart-remove-status]');

      function getRoot() {
        return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      }

      function rebuildAfterRemoval(cart) {
        return new Promise(function (resolve, reject) {
          var timeout;
          var observer = new MutationObserver(function () {
            var items = products.querySelector('.cart__items');
            if (!items || Number(items.dataset.count) !== cart.item_count || Number(items.dataset.cartSubtotal) !== cart.total_price) return;
            observer.disconnect();
            window.clearTimeout(timeout);
            resolve();
          });
          observer.observe(products, { childList: true });
          timeout = window.setTimeout(function () {
            observer.disconnect();
            reject(new Error('Cart refresh did not finish'));
          }, 8000);
          document.dispatchEvent(new CustomEvent('cart:build'));
        });
      }

      async function removeItem(link) {
        var item = link.closest('.cart__item');
        var key = item && item.dataset.key;
        if (!key || removing) return;
        var index = Array.from(products.querySelectorAll('.cart__item')).indexOf(item);
        var controls = Array.from(drawer.querySelectorAll('.js-qty__adjust, .js-qty__num, [data-cart-addon-add], .cart__checkout'));
        var controlStates = controls.map(function (control) { return control.disabled; });
        removing = true;
        removalError.hidden = true;
        removalStatus.textContent = '';
        products.setAttribute('aria-busy', 'true');
        link.setAttribute('aria-disabled', 'true');
        controls.forEach(function (control) { control.disabled = true; });
        try {
          var response = await window.fetch(getRoot() + 'cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          var cart = await response.json();
          if (!response.ok || cart.status) throw new Error('Cart update failed');
          await rebuildAfterRemoval(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          removalStatus.textContent = removalStatus.dataset.removedLabel;
          if (drawer.classList.contains('drawer--is-open')) {
            var remaining = products.querySelectorAll('.cart__remove a');
            var focusTarget = remaining[Math.min(index, remaining.length - 1)] || drawer.querySelector('.drawer__cart-empty a') || drawer.querySelector('.js-drawer-close');
            focusTarget.focus({ preventScroll: true });
          }
          refresh();
        } catch (error) {
          removalError.hidden = false;
          if (drawer.classList.contains('drawer--is-open')) removalError.querySelector('a').focus({ preventScroll: true });
        } finally {
          removing = false;
          products.removeAttribute('aria-busy');
          link.removeAttribute('aria-disabled');
          controls.forEach(function (control, controlIndex) { control.disabled = controlStates[controlIndex]; });
        }
      }

      function addVariant(variantId, button) {
        button.disabled = true;
        button.textContent = button.dataset.addingLabel || button.dataset.defaultLabel;

        return window.fetch(getRoot() + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw new Error(data.description || 'Unable to add item');
              return data;
            });
          })
          .then(function (product) {
            button.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              bubbles: true,
              detail: { product: product, addToCartBtn: button }
            }));
            return product;
          })
          .catch(function () {
            button.textContent = button.dataset.errorLabel || button.dataset.defaultLabel;
            throw new Error('Unable to add item');
          })
          .finally(function () {
            window.setTimeout(function () {
              button.disabled = false;
              button.textContent = button.dataset.defaultLabel;
            }, 900);
          });
      }

      function normalizeDiscountLabels() {
        var discounts = drawer.querySelector('[data-discounts]');
        if (!discounts) return;
        discounts.querySelectorAll('.cart__discount').forEach(function (row) {
          var amount = row.textContent.match(/\(-[^)]+\)/);
          var nextText = panel.dataset.savingsLabel + (amount ? ' ' + amount[0] : '');
          if (row.textContent.trim() !== nextText) row.textContent = nextText;
        });
      }

      function schedule() {
        normalizeDiscountLabels();
        window.clearTimeout(timer);
        timer = window.setTimeout(refresh, 100);
      }

      function updateTierProgress(itemCount) {
        var tierProgress = drawer.querySelector('[data-cart-tier-progress]');
        if (!tierProgress) return;

        var steps = Array.from(tierProgress.querySelectorAll('[data-cart-tier-step]'));
        var achieved = steps.filter(function (step) { return itemCount >= Number(step.dataset.cartTierStep); }).length;
        var progress = steps.length > 1 ? Math.max(0, achieved - 1) / (steps.length - 1) * 100 : 0;

        tierProgress.style.setProperty('--ccp-tier-progress', progress + '%');
        tierProgress.setAttribute('aria-valuenow', String(achieved));
        tierProgress.setAttribute('aria-valuemax', String(steps.length));
        steps.forEach(function (step) {
          step.classList.toggle('is-unlocked', itemCount >= Number(step.dataset.cartTierStep));
        });
      }

      function lockQuantityInputs() {
        drawer.querySelectorAll('.js-qty__num').forEach(function (input) {
          input.readOnly = true;
          input.setAttribute('inputmode', 'none');
          input.setAttribute('tabindex', '-1');
        });
      }

      var savingsRequest = 0;
      function refreshSavings() {
        var target = drawer.querySelector('[data-cart-savings]');
        if (!target) return;
        var request = ++savingsRequest;
        target.hidden = true;
        window.fetch(getRoot() + '?section_id=ccp-cart-savings', { cache: 'no-store' })
          .then(function (response) {
            if (!response.ok) throw new Error('Savings unavailable');
            return response.text();
          })
          .then(function (html) {
            if (request !== savingsRequest) return;
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var content = parsed.querySelector('[data-cart-savings-content]');
            if (!content) return;
            target.replaceChildren(content);
            target.hidden = false;
          })
          .catch(function () {});
      }

      function refresh() {
        refreshSavings();
        lockQuantityInputs();
        window.fetch(getRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            updateTierProgress(cart.item_count);
            if (country !== 'US') return;

            var remaining = Math.max(25000 - cart.total_price, 0);
            var progress = Math.min(cart.total_price / 250, 100);

            if (copy) {
              if (remaining > 0) {
                var amount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(remaining / 100);
                copy.textContent = panel.dataset.awayTemplate.replace('&#39;', "'").replace('[amount]', amount);
              } else {
                copy.textContent = panel.dataset.unlockedTemplate;
              }
            }

            if (meter) {
              meter.setAttribute('aria-valuenow', String(Math.round(progress)));
              meter.style.setProperty('--ccp-drawer-shipping-progress', progress + '%');
            }
          })
          .catch(function () {});
      }

      var products = drawer.querySelector('[data-products]');
      var subtotal = drawer.querySelector('[data-subtotal]');
      function syncCheckoutSubtotal() {
        var amount = drawer.querySelector('[data-checkout-subtotal]');
        if (subtotal && amount) amount.textContent = subtotal.textContent.trim();
      }
      syncCheckoutSubtotal();
      if (products) new MutationObserver(function () {
        lockQuantityInputs();
        schedule();
      }).observe(products, { childList: true, subtree: true });
      if (subtotal) new MutationObserver(function () {
        syncCheckoutSubtotal();
        schedule();
      }).observe(subtotal, { childList: true, subtree: true, characterData: true });

      drawer.addEventListener('click', function (event) {
        var link = event.target.closest('.cart__remove a');
        if (removing && event.target.closest('.js-qty__adjust, .cart__remove a, [data-cart-addon-add], .cart__checkout')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        removeItem(link);
      }, true);

      drawer.addEventListener('click', function (event) {
        var swatch = event.target.closest('[data-cart-addon-swatch]');
        if (swatch) {
          var addonCard = swatch.closest('[data-cart-addon-card]');
          var addonImage = addonCard.querySelector('.ccp-cart-drawer__addon-image img');
          var addonPrice = addonCard.querySelector('[data-cart-addon-price]');
          var addonButton = addonCard.querySelector('[data-cart-addon-add]');
          addonCard.querySelectorAll('[data-cart-addon-swatch]').forEach(function (item) {
            var active = item === swatch;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          addonButton.dataset.variantId = swatch.dataset.variantId;
          addonPrice.textContent = swatch.dataset.variantPrice;
          if (swatch.dataset.variantImage && addonImage) {
            addonImage.src = swatch.dataset.variantImage;
            addonImage.removeAttribute('srcset');
          }
          return;
        }

        var addonButton = event.target.closest('[data-cart-addon-add]');
        if (addonButton) {
          addVariant(addonButton.dataset.variantId, addonButton).catch(function () {});
          return;
        }

        if (event.target.closest('.js-qty__adjust')) {
          window.setTimeout(refresh, 500);
          window.setTimeout(refresh, 1400);
        }
      });

      drawer.addEventListener('change', function (event) {
        if (event.target.matches('.js-qty__num')) window.setTimeout(refresh, 700);
        if (event.target === giftToggle && giftMessage) {
          giftMessage.hidden = !giftToggle.checked;
          if (giftToggle.checked) giftMessage.focus();
        }
      });

      if (giftToggle && giftMessage && giftMessage.value.trim()) {
        giftToggle.checked = true;
        giftMessage.hidden = false;
      }
      refresh();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initNativeDrawerShipping);
    } else {
      initNativeDrawerShipping();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ccp-collection-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.body.classList.contains('template-collection')) return;
    const storageKey = 'ccp:collection-return:v1';
    let pendingReturn = null;
    let returnTimers = [];

    const pageKey = () => location.pathname + location.search;
    const cancelReturn = () => {
      pendingReturn = null;
      returnTimers.forEach(clearTimeout);
      returnTimers = [];
    };
    const restorePosition = () => {
      if (!pendingReturn || pendingReturn.url !== pageKey()) return;
      const card = Array.from(document.querySelectorAll('#CollectionAjaxContent .grid-product')).find(item => item.dataset.productId === pendingReturn.productId);
      const top = card ? scrollY + card.getBoundingClientRect().top - pendingReturn.offset : pendingReturn.y;
      if (Math.abs(scrollY - top) > 3) window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
    };

    const enhanceCollection = () => {
      const configuration = document.querySelector('[data-ccp-collection-mobile]');
      const currentSort = new URL(location.href).searchParams.get('sort_by');
      const select = document.querySelector('#SortBy');
      const resultCount = document.querySelector('[data-ccp-result-count]');
      const viewResults = document.querySelector('#FilterDrawer .ccp-filter-drawer__view');
      if (viewResults && resultCount) viewResults.textContent = resultCount.dataset.resultsLabel;
      const sortValue = document.querySelector('.collection-filter__sort-value');
      if (select && sortValue) sortValue.textContent = select.selectedOptions[0]?.textContent || '';

      document.querySelectorAll('.ccp-collection-hero__shortcut').forEach(link => {
        const url = new URL(link.href);
        const active = url.pathname === location.pathname && url.searchParams.get('sort_by') === currentSort;
        if (active) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
      document.querySelectorAll('.ccp-filter-drawer__clear, .collection-active-filters__clear').forEach(link => {
        if (!currentSort) return;
        const url = new URL(link.href);
        url.searchParams.set('sort_by', currentSort);
        link.href = url.href;
      });
      if (configuration) {
        document.querySelectorAll('#FilterDrawer .price-range__slider [role="slider"]').forEach((slider, index) => {
          slider.setAttribute('aria-label', index % 2 === 0 ? configuration.dataset.minLabel : configuration.dataset.maxLabel);
        });
      }
      if (pendingReturn) requestAnimationFrame(restorePosition);
    };

    document.addEventListener('click', event => {
      const link = event.target.closest('#CollectionAjaxContent .grid-product a[href]');
      if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.href);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
      const card = link.closest('.grid-product');
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          url: pageKey(), productId: card.dataset.productId,
          offset: card.getBoundingClientRect().top, y: scrollY, time: Date.now()
        }));
      } catch {}
    }, true);

    const onPageShow = event => {
      enhanceCollection();
      const navigation = performance.getEntriesByType('navigation')[0];
      if (!event.persisted && navigation?.type !== 'back_forward') return;
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey));
        if (!saved || saved.url !== pageKey() || Date.now() - saved.time > 1800000) return;
        if (!Number.isFinite(saved.y) || !Number.isFinite(saved.offset)) return;
        pendingReturn = saved;
        requestAnimationFrame(() => requestAnimationFrame(restorePosition));
        returnTimers = [150, 500, 1200].map(delay => setTimeout(restorePosition, delay));
        returnTimers.push(setTimeout(cancelReturn, 4000));
      } catch {}
    };
    window.addEventListener('pageshow', onPageShow);
    window.addEventListener('pagehide', cancelReturn);
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(type => window.addEventListener(type, cancelReturn, { passive: true }));
    document.addEventListener('collection:reloaded', enhanceCollection);
    document.addEventListener('shopify:section:load', enhanceCollection);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceCollection, { once: true });
    else enhanceCollection();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ccp-collection-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
    const ready = () => {
      const config = document.querySelector('[data-ccp-shopping-config]');
      const dialog = document.getElementById('CcpCollectionQuickAdd');
      if (!config || !dialog || dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      const copy = config.dataset;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const imageUrl = (source, width = 720) => {
        try {
          const url = new URL(source, location.origin);
          if (!['http:', 'https:'].includes(url.protocol)) return '';
          url.searchParams.set('width', width);
          return url.href;
        } catch { return ''; }
      };
      const imageKey = source => { try { return new URL(source, location.origin).pathname; } catch { return source; } };
      const initializeGalleries = () => document.querySelectorAll('[data-ccp-card-gallery]:not([data-ready])').forEach(gallery => {
        gallery.dataset.ready = 'true';
        const data = gallery.querySelector('[data-ccp-gallery-images]');
        if (!data) return;
        let images;
        try { images = JSON.parse(data.textContent).filter(source => typeof source === 'string' && source); } catch { return; }
        const featured = gallery.dataset.featuredSrc;
        images = [featured, ...images.filter(source => imageKey(source) !== imageKey(featured))].filter(Boolean);
        if (images.length < 2) return;
        const track = gallery.querySelector('[data-ccp-gallery-track]');
        const firstSlide = track.firstElementChild;
        const slides = [firstSlide];
        const dots = gallery.querySelector('[data-ccp-gallery-dots]');
        const status = gallery.querySelector('[data-ccp-gallery-status]');
        let current = 0;
        let scrollFrame = 0;
        let startX = 0;
        let moved = false;
        let suppressUntil = 0;
        images.slice(1).forEach((source, index) => {
          const slide = firstSlide.cloneNode(false);
          slide.tabIndex = -1;
          slide.setAttribute('aria-hidden', 'true');
          slide.dataset.src = source;
          track.append(slide);
          slides.push(slide);
        });
        const loadImage = index => {
          const slide = slides[index];
          if (!slide || !slide.dataset.src || slide.firstElementChild) return;
          const img = document.createElement('img');
          img.width = 720; img.height = 720; img.alt = gallery.dataset.title;
          img.decoding = 'async'; img.draggable = false;
          const firstImage = firstSlide.querySelector('img');
          img.sizes = (firstImage?.getAttribute('sizes') || '(max-width: 768px) 50vw, 25vw').replace(/^auto,\s*/, '');
          img.srcset = [240, 360, 480, 720].map(width => imageUrl(slide.dataset.src, width) + ' ' + width + 'w').join(', ');
          img.src = imageUrl(slide.dataset.src);
          slide.append(img);
        };
        const loadNearby = index => [index - 1, index, index + 1].forEach(loadImage);
        const draw = (announce = false) => {
          const start = Math.max(0, Math.min(current - 2, images.length - 5));
          dots.replaceChildren();
          for (let index = start; index < Math.min(start + 5, images.length); index++) {
            const dot = document.createElement('span');
            dot.className = 'ccp-card-gallery__dot' + (index === current ? ' is-active' : '') + ((index === start && start > 0 || index === start + 4 && index < images.length - 1) ? ' is-edge' : '');
            dots.append(dot);
          }
          slides.forEach((slide, index) => { slide.tabIndex = index === current ? 0 : -1; slide.setAttribute('aria-hidden', String(index !== current)); });
          if (announce) status.textContent = status.dataset.label.replace('[current]', current + 1).replace('[total]', images.length);
        };
        gallery.querySelectorAll('[data-ccp-gallery-step]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            const target = (current + Number(button.dataset.ccpGalleryStep) + images.length) % images.length;
            loadNearby(target);
            track.scrollTo({ left: target * track.clientWidth, behavior: reducedMotion.matches || Math.abs(target - current) > 1 ? 'instant' : 'smooth' });
          });
        });
        track.addEventListener('scroll', () => {
          if (scrollFrame) return;
          scrollFrame = requestAnimationFrame(() => {
            scrollFrame = 0;
            const next = Math.max(0, Math.min(images.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
            loadNearby(next);
            if (next !== current) { current = next; draw(true); }
          });
        }, { passive: true });
        track.addEventListener('pointerdown', event => { startX = event.clientX; moved = false; });
        track.addEventListener('pointermove', event => { if (event.buttons && Math.abs(event.clientX - startX) > 8) moved = true; }, { passive: true });
        track.addEventListener('pointercancel', () => { suppressUntil = Date.now() + 500; });
        track.addEventListener('pointerup', () => { if (moved) suppressUntil = Date.now() + 500; });
        track.addEventListener('click', event => { if (Date.now() < suppressUntil) { event.preventDefault(); event.stopPropagation(); } }, true);
        const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { loadNearby(0); observer.disconnect(); } }, { rootMargin: '100px' });
        observer.observe(gallery);
        draw();
      });

      const ui = suffix => dialog.querySelector('[data-ccp-quick-' + suffix + ']');
      const form = ui('form');
      const quantity = form.elements.quantity;
      const submit = ui('submit');
      const cache = new Map();
      let activeTrigger = null;
      let activeProduct = null;
      let selectedVariant = null;
      let version = 0;
      let submitting = false;
      let uncertain = false;
      let editMode = false;
      let editingLine = null;
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: copy.currency || 'USD' }).format(value / 100);
      const root = () => window.Shopify?.routes?.root || '/';
      const returnToDrawer = key => {
        document.dispatchEvent(new CustomEvent('cart:open'));
        requestAnimationFrame(() => {
          const drawer = document.getElementById('CartDrawer');
          const item = Array.from(drawer?.querySelectorAll('[data-key]') || []).find(line => line.dataset.key === key);
          if (!dialog.open) (item?.querySelector('[data-ccp-edit-options]') || drawer?.querySelector('.js-drawer-close'))?.focus({ preventScroll: true });
        });
      };
      const close = (returnDrawer = true) => {
        if (submitting) return;
        version++;
        dialog.close();
        document.body.classList.remove('ccp-quick-add-open');
        if (editMode && returnDrawer) returnToDrawer(editingLine?.key || activeTrigger?.closest('[data-key]')?.dataset.key);
        else if (!editMode) activeTrigger?.focus({ preventScroll: true });
      };
      const error = text => { ui('error').textContent = text; ui('error').hidden = false; };
      const cartRequest = async (path, body) => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(root() + path, {
            method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            ...(body ? { body: JSON.stringify(body) } : {})
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : copy.addError);
          return data;
        } finally { clearTimeout(timeout); }
      };
      const editableLine = item => item && item.quantity > 0 && !Object.keys(item.properties || {}).length && !item.selling_plan_allocation && !item.item_components?.length && !item.parent_relationship;
      const matchingLines = (cart, id) => cart.items.filter(item => String(item.variant_id || item.id) === String(id) && editableLine(item));
      const lineIdentity = item => JSON.stringify([
        String(item.variant_id || item.id), Object.entries(item.properties || {}).sort(),
        item.selling_plan_allocation?.selling_plan?.id || null, item.parent_relationship || null,
        (item.item_components || []).map(part => [part.variant_id || part.id, part.quantity])
      ]);
      const cartShape = items => {
        const totals = new Map();
        items.forEach(item => { const key = lineIdentity(item); totals.set(key, (totals.get(key) || 0) + item.quantity); });
        return JSON.stringify(Array.from(totals.entries()).filter(([, count]) => count > 0).sort());
      };
      const replaceCartLine = async (source, id) => {
        let attempted = false;
        try {
          const before = await cartRequest('cart.js');
          const originals = matchingLines(before, source.variant_id || source.id);
          if (originals.length !== 1 || originals[0].quantity !== source.quantity) throw new Error(copy.cartChanged);
          const original = originals[0];
          if (String(original.variant_id || original.id) === String(id)) return before;
          const targets = matchingLines(before, id);
          if (targets.length > 1) throw new Error(copy.cartChanged);
          const expected = before.items.map(item => ({ ...item }));
          const target = expected.find(item => lineIdentity(item) === lineIdentity(targets[0] || { id }));
          if (target) target.quantity += source.quantity;
          else expected.push({ id, variant_id: id, quantity: source.quantity, properties: {} });
          attempted = true;
          await cartRequest('cart/add.js', { id, quantity: source.quantity });
          const afterAdd = await cartRequest('cart.js');
          const remainingOriginals = matchingLines(afterAdd, original.variant_id || original.id);
          if (cartShape(afterAdd.items) !== cartShape(expected) || remainingOriginals.length !== 1 || remainingOriginals[0].quantity !== source.quantity) throw new Error(copy.editUnconfirmed);
          const finalCart = await cartRequest('cart/change.js', { id: remainingOriginals[0].key, quantity: 0 });
          const expectedFinal = expected.filter(item => lineIdentity(item) !== lineIdentity(original));
          if (cartShape(finalCart.items) !== cartShape(expectedFinal)) throw new Error(copy.editUnconfirmed);
          return finalCart;
        } catch (reason) {
          if (attempted) { reason.needsReview = true; reason.message = copy.editUnconfirmed; }
          throw reason;
        }
      };
      const refreshDrawer = cart => new Promise((resolve, reject) => {
        const products = document.querySelector('#CartDrawer [data-products]');
        if (!products) { reject(new Error(copy.refreshError)); return; }
        let timer;
        const observer = new MutationObserver(() => {
          const items = products.querySelector('.cart__items');
          const actual = Array.from(products.querySelectorAll('[data-key]')).map(item => [item.dataset.key, Number(item.querySelector('[name="updates[]"]')?.value)]).sort();
          const expected = cart.items.map(item => [item.key, item.quantity]).sort();
          if (!items || Number(items.dataset.cartSubtotal) !== cart.total_price || JSON.stringify(actual) !== JSON.stringify(expected)) return;
          observer.disconnect(); clearTimeout(timer); resolve();
        });
        observer.observe(products, { childList: true });
        timer = setTimeout(() => { observer.disconnect(); reject(new Error(copy.refreshError)); }, 8000);
        document.dispatchEvent(new CustomEvent('cart:build'));
      });
      const readChoices = () => Array.from(ui('options').querySelectorAll('[data-ccp-option-index]')).map(group => group.querySelector('select')?.value ?? group.querySelector('input:checked')?.value ?? '');
      const choiceMemory = new Map();
      const choiceStorageKey = product => copy.choiceStoragePrefix + ':' + product.id;
      const readRememberedChoices = product => {
        const key = choiceStorageKey(product);
        let saved = choiceMemory.get(key);
        if (!saved) {
          try { saved = JSON.parse(window.sessionStorage.getItem(key) || 'null'); } catch { return null; }
        }
        if (!saved || !Array.isArray(saved.names) || !Array.isArray(saved.values) || saved.names.length !== product.options.length || saved.values.length !== product.options.length) return null;
        if (!product.options.every((option, index) => option.name === saved.names[index] && typeof saved.values[index] === 'string' && option.values.includes(saved.values[index]))) return null;
        return saved.values.slice();
      };
      const rememberChoices = () => {
        if (editMode || !activeProduct || ui('product').hidden || !dialog.open) return;
        const values = readChoices();
        if (values.length !== activeProduct.options.length || !activeProduct.options.every((option, index) => option.values.includes(values[index]))) return;
        const key = choiceStorageKey(activeProduct);
        const saved = { names: activeProduct.options.map(option => option.name), values };
        choiceMemory.set(key, saved);
        try { window.sessionStorage.setItem(key, JSON.stringify(saved)); } catch {}
      };
      const updateSelection = () => {
        const values = readChoices();
        if (editMode || !values.length || Number(quantity.value) > 1) values.push(copy.quantityLabel + ': ' + (quantity.value || '—'));
        ui('selection').textContent = values.join(' · ');
      };
      let sizeGuides = {};
      try { sizeGuides = JSON.parse(document.querySelector('[data-ccp-quick-size-data]')?.textContent || '{}'); } catch {}
      const productGuideRows = (product, option, isEditing) => {
        if (isEditing || !sizeGuides || !Object.hasOwn(sizeGuides, String(product.id))) return [];
        const guide = sizeGuides[String(product.id)];
        if (!guide || guide.handle !== product.handle || guide.option !== option.name) return [];
        const measurements = guide.measurements;
        if (!measurements || typeof measurements !== 'object') return [];
        if (!Array.isArray(option.values) || !option.values.length || !option.values.every(value => Object.hasOwn(measurements, value))) return [];
        if (!option.values.every(value => Array.isArray(measurements[value]) && measurements[value].length === 3 && measurements[value].every(cm => Number.isFinite(cm) && cm > 0))) return [];
        return option.values.map(value => ({ value, cm: measurements[value], inches: measurements[value].map(cm => (cm / 2.54).toFixed(1)) }));
      };
      const appendSizeGuide = (product, option, group, legend) => {
        const rows = productGuideRows(product, option, editMode);
        const template = document.querySelector('[data-ccp-size-guide-template]');
        if (!rows.length || !template) return;
        const panel = template.content.firstElementChild.cloneNode(true);
        panel.id += '-' + group.dataset.ccpOptionIndex;
        const toggle = document.createElement('button');
        toggle.type = 'button'; toggle.className = 'ccp-quick-add__size-guide-toggle';
        toggle.textContent = copy.sizeGuide;
        toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-controls', panel.id);
        const sizeLabel = document.createElement('span');
        sizeLabel.id = 'CcpQuickSizeLabel-' + group.dataset.ccpOptionIndex; sizeLabel.textContent = option.name;
        legend.replaceChildren(sizeLabel, toggle);
        group.setAttribute('aria-labelledby', sizeLabel.id); group.classList.add('ccp-quick-add__sizes--guided');
        rows.forEach(({ value, cm, inches }) => {
          const row = document.createElement('tr'); row.dataset.ccpGuideSize = value;
          const name = document.createElement('th'); name.scope = 'row'; name.textContent = value;
          const dimensions = document.createElement('td');
          const metric = document.createElement('span'); metric.textContent = cm.join(' × ') + ' ' + copy.sizeCm;
          const imperial = document.createElement('span'); imperial.textContent = inches.join(' × ') + ' ' + copy.sizeIn;
          dimensions.append(metric, imperial); row.append(name, dimensions); panel.querySelector('tbody').append(row);
        });
        toggle.addEventListener('click', () => { panel.hidden = !panel.hidden; toggle.setAttribute('aria-expanded', String(!panel.hidden)); });
        group.append(panel);
      };
      const isColourOption = option => /^colou?r(?:\s*\/\s*(?:size|hardware\s+colou?r)|\s*-\s*presale)?$/i.test(option.name.trim());
      const usesColourPhotos = (product, option, isEditing) => !isEditing && isColourOption(option) && product.variants.some(variant => variant.featured_image?.src);
      const colourPhoto = (product, index, value, choices) => {
        const matches = product.variants.filter(variant => variant.options[index] === value && variant.featured_image?.src);
        let best = null;
        let bestScore = -1;
        matches.forEach(variant => {
          const score = variant.options.reduce((total, item, position) => total + (position !== index && choices[position] === item ? 1 : 0), 0);
          if (score > bestScore) { best = variant; bestScore = score; }
        });
        return best?.featured_image?.src || '';
      };
      const syncColourStrips = (reveal = false) => {
        dialog.querySelectorAll('[data-ccp-colour-track]').forEach(track => {
          const group = track.closest('[data-ccp-option-index]');
          const input = track.querySelector('input:checked');
          group.querySelector('[data-ccp-colour-name]').textContent = input?.value || '';
          if (reveal && input && track.clientWidth) {
            const tile = input.closest('label').getBoundingClientRect();
            const bounds = track.getBoundingClientRect();
            if (tile.left < bounds.left + 3 || tile.right > bounds.right - 3) track.scrollTo({ left: track.scrollLeft + tile.left - bounds.left - (track.clientWidth - tile.width) / 2, behavior: 'instant' });
          }
          group.querySelector('[data-ccp-colour-prev]').disabled = track.scrollLeft <= 2;
          group.querySelector('[data-ccp-colour-next]').disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        });
      };
      const appendColourPhotos = (product, option, index, choices) => {
        const group = document.createElement('fieldset');
        group.className = 'ccp-quick-add__colours'; group.dataset.ccpOptionIndex = index;
        const legend = document.createElement('legend');
        const heading = document.createElement('span'); heading.className = 'ccp-quick-add__colour-heading';
        const name = document.createElement('span'); name.id = 'CcpQuickColourLabel-' + index; name.textContent = option.name;
        const selected = document.createElement('span'); selected.dataset.ccpColourName = ''; selected.textContent = choices[index];
        heading.append(name, ': ', selected); group.setAttribute('aria-labelledby', name.id);
        const controls = document.createElement('span'); controls.className = 'ccp-quick-add__colour-controls';
        const track = document.createElement('div'); track.className = 'ccp-quick-add__colour-track'; track.dataset.ccpColourTrack = '';
        const arrow = (direction, label) => {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'ccp-quick-add__colour-arrow'; button.setAttribute('aria-label', label);
          button.dataset[direction < 0 ? 'ccpColourPrev' : 'ccpColourNext'] = '';
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path'); path.setAttribute('d', direction < 0 ? 'm14 5-7 7 7 7' : 'm10 5 7 7-7 7'); svg.append(path); button.append(svg);
          button.addEventListener('click', () => track.scrollBy({ left: direction * Math.max(72, Math.floor(track.clientWidth / 72) * 72), behavior: reducedMotion.matches ? 'instant' : 'smooth' }));
          return button;
        };
        controls.append(arrow(-1, copy.colourPrevious), arrow(1, copy.colourNext)); legend.append(heading, controls);
        option.values.forEach((value, valueIndex) => {
          const label = document.createElement('label'); label.className = 'ccp-quick-add__colour-choice'; label.title = value;
          const input = document.createElement('input'); input.type = 'radio'; input.name = 'options[' + option.name + ']'; input.value = value;
          input.id = 'CcpQuickOption-' + index + '-' + valueIndex; input.checked = value === choices[index]; input.required = true; input.setAttribute('aria-label', value);
          const tile = document.createElement('span'); tile.className = 'ccp-quick-add__colour-tile'; tile.setAttribute('aria-hidden', 'true');
          const fallback = document.createElement('span'); fallback.className = 'ccp-quick-add__colour-fallback'; fallback.textContent = value;
          const source = colourPhoto(product, index, value, choices);
          if (source) {
            const image = document.createElement('img'); image.alt = ''; image.width = 54; image.height = 54; image.loading = 'lazy'; image.decoding = 'async';
            image.src = imageUrl(source, 144); fallback.hidden = true;
            image.addEventListener('error', () => { image.hidden = true; fallback.hidden = false; }); tile.append(image);
          }
          tile.append(fallback); label.append(input, tile); track.append(label);
          input.addEventListener('change', updateVariant);
        });
        track.addEventListener('scroll', () => syncColourStrips(), { passive: true });
        group.append(legend, track); ui('options').append(group);
      };
      const updateVariant = () => {
        const choices = readChoices();
        selectedVariant = activeProduct.variants.find(variant => choices.length ? variant.options.every((value, index) => value === choices[index]) : true);
        const available = selectedVariant?.available && !selectedVariant.requires_selling_plan;
        const rule = selectedVariant?.quantity_rule;
        const amount = Number(quantity.value);
        const quantityAllowed = !editMode || (amount >= (rule?.min || 1) && (!rule?.max || amount <= rule.max) && (amount - (rule?.min || 1)) % (rule?.increment || 1) === 0);
        ui('variant').value = selectedVariant?.id || '';
        submit.disabled = !available || !quantityAllowed || submitting || uncertain;
        submit.textContent = available && quantityAllowed ? (editMode ? copy.saveChanges : copy.addLabel) : copy.notAvailable;
        ui('availability').textContent = !available ? copy.unavailable : !quantityAllowed ? copy.quantityUnavailable : '';
        if (!uncertain) ui('error').hidden = true;
        const price = selectedVariant?.price;
        const compare = selectedVariant?.compare_at_price || 0;
        ui('price').textContent = selectedVariant ? money(price) : copy.notAvailable;
        ui('price').dataset.onSale = String(compare > price);
        ui('compare').hidden = !selectedVariant || compare <= price;
        ui('compare').textContent = compare > price ? money(compare) : '';
        ui('footer-price').textContent = ui('price').textContent;
        ui('footer-price').dataset.onSale = String(compare > price);
        ui('each').hidden = !selectedVariant;
        const colourIndex = editMode ? -1 : activeProduct.options.findIndex(isColourOption);
        const colourImage = colourIndex >= 0 ? colourPhoto(activeProduct, colourIndex, choices[colourIndex], choices) : '';
        const image = selectedVariant?.featured_image?.src || (colourIndex >= 0 ? colourImage : activeProduct.featured_image);
        ui('image').hidden = !image;
        if (image) { ui('image').src = imageUrl(image, 320); ui('image').alt = activeProduct.title + (selectedVariant ? ' — ' + selectedVariant.title : ''); }
        const min = selectedVariant?.quantity_rule?.min || 1;
        quantity.min = min;
        quantity.step = selectedVariant?.quantity_rule?.increment || 1;
        if (selectedVariant?.quantity_rule?.max) quantity.max = selectedVariant.quantity_rule.max;
        else quantity.removeAttribute('max');
        if (!editMode && !quantity.checkValidity()) quantity.value = min;
        const details = new URL(activeTrigger.href);
        if (selectedVariant) details.searchParams.set('variant', selectedVariant.id);
        ui('details').href = details.href;
        dialog.querySelectorAll('[data-ccp-guide-size]').forEach(row => {
          const chosenSize = row.closest('[data-ccp-option-index]').querySelector('input:checked')?.value;
          if (row.dataset.ccpGuideSize === chosenSize) row.setAttribute('aria-current', 'true');
          else row.removeAttribute('aria-current');
        });
        updateSelection();
        syncColourStrips(true);
      };
      const loadProduct = async trigger => {
        const url = new URL(trigger.dataset.productUrl, location.origin);
        url.pathname += '.js';
        url.search = '';
        const path = url.href;
        const previous = cache.get(path);
        if (previous && Date.now() - previous.time < 60000) return previous.promise;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 12000);
        const promise = fetch(path, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal }).then(response => {
          if (!response.ok) throw new Error('Product unavailable');
          return response.json();
        }).catch(reason => { cache.delete(path); throw reason; }).finally(() => clearTimeout(timer));
        cache.set(path, { time: Date.now(), promise });
        return promise;
      };
      const populate = async () => {
        const requestVersion = ++version;
        ui('product').hidden = true; ui('footer').hidden = true; ui('retry').hidden = true;
        ui('error').hidden = true; ui('view-bag').hidden = true; ui('load').textContent = copy.loading;
        ui('details').href = activeTrigger.href;
        uncertain = false;
        try {
          const [product, cart] = await Promise.all([loadProduct(activeTrigger), editMode ? cartRequest('cart.js') : Promise.resolve(null)]);
          if (requestVersion !== version || !dialog.open) return;
          if (editMode) {
            editingLine = cart.items.find(item => item.key === activeTrigger.closest('[data-key]')?.dataset.key);
            if (!editableLine(editingLine) || matchingLines(cart, editingLine.variant_id || editingLine.id).length !== 1) {
              ui('load').textContent = copy.cartChanged; ui('view-bag').hidden = false;
              document.dispatchEvent(new CustomEvent('cart:build')); return;
            }
          }
          if (!Array.isArray(product.variants) || !product.variants.length || Number(activeTrigger.dataset.variantCount) > product.variants.length || product.requires_selling_plan) {
            ui('load').textContent = copy.fullOptions; return;
          }
          activeProduct = product;
          ui('title').textContent = product.title;
          ui('options').querySelectorAll('[data-ccp-option-index]').forEach(group => group.remove());
          const requestedVariant = editMode ? String(editingLine.variant_id || editingLine.id) : new URL(activeTrigger.href).searchParams.get('variant');
          if (editMode && !product.variants.some(variant => String(variant.id) === requestedVariant)) {
            ui('load').textContent = copy.fullOptions; return;
          }
          const initial = product.variants.find(variant => String(variant.id) === requestedVariant) || product.variants.find(variant => variant.available) || product.variants[0];
          const initialChoices = (!editMode && !requestedVariant && readRememberedChoices(product)) || initial.options;
          const isDefault = product.variants.length === 1 && product.variants[0].title === 'Default Title';
          let selectCount = 0;
          if (!isDefault) product.options.forEach((option, index) => {
            if (usesColourPhotos(product, option, editMode)) { appendColourPhotos(product, option, index, initialChoices); return; }
            const isSize = option.name.trim().toLocaleLowerCase() === (copy.sizeTrigger || 'Size').trim().toLocaleLowerCase() || /^sizes?$/i.test(option.name.trim());
            if (isSize) {
              const group = document.createElement('fieldset');
              group.className = 'ccp-quick-add__sizes'; group.dataset.ccpOptionIndex = index;
              const legend = document.createElement('legend'); legend.textContent = option.name;
              const list = document.createElement('div'); list.className = 'ccp-quick-add__size-list';
              option.values.forEach((value, valueIndex) => {
                const label = document.createElement('label'); label.className = 'ccp-quick-add__size-choice';
                const input = document.createElement('input');
                input.type = 'radio'; input.name = 'options[' + option.name + ']'; input.value = value;
                input.id = 'CcpQuickOption-' + index + '-' + valueIndex;
                input.checked = value === initialChoices[index]; input.required = true;
                input.addEventListener('change', updateVariant);
                const text = document.createElement('span'); text.textContent = value;
                label.append(input, text); list.append(label);
              });
              group.append(legend, list); ui('options').append(group);
              appendSizeGuide(product, option, group, legend);
              return;
            }
            selectCount++;
            const label = document.createElement('label');
            label.className = 'ccp-quick-add__select-option'; label.dataset.ccpOptionIndex = index;
            label.textContent = option.name;
            const select = document.createElement('select');
            select.name = 'options[' + option.name + ']';
            select.required = true;
            option.values.forEach(value => { const item = document.createElement('option'); item.value = value; item.textContent = value; item.selected = value === initialChoices[index]; select.append(item); });
            select.addEventListener('change', updateVariant);
            label.append(select); ui('options').append(label);
          });
          ui('options').dataset.selectCount = selectCount;
          ui('options').hidden = isDefault;
          quantity.value = editMode ? editingLine.quantity : initial.quantity_rule?.min || 1;
          ui('product').hidden = false; ui('footer').hidden = false; ui('load').textContent = '';
          updateVariant();
          requestAnimationFrame(() => { if (requestVersion === version && dialog.open) syncColourStrips(true); });
        } catch {
          if (requestVersion !== version || !dialog.open) return;
          ui('load').textContent = copy.loadError; ui('retry').hidden = false;
        }
      };
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-ccp-quick-add], #CartDrawer [data-ccp-edit-options]');
        if (!trigger || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        if (submitting) return;
        activeTrigger = trigger;
        editMode = trigger.hasAttribute('data-ccp-edit-options');
        editingLine = null;
        document.getElementById('CcpQuickAddHeading').textContent = editMode ? copy.editOptions : copy.quickAdd;
        quantity.closest('label').hidden = editMode;
        quantity.disabled = editMode;
        ui('edit-note').hidden = !editMode;
        ui('cancel').hidden = !editMode;
        if (editMode) document.dispatchEvent(new CustomEvent('cart:close'));
        dialog.showModal();
        document.body.classList.add('ccp-quick-add-open');
        ui('close').focus();
        populate();
      });
      ui('close').addEventListener('click', () => close());
      ui('cancel').addEventListener('click', () => close());
      quantity.addEventListener('input', updateSelection);
      window.addEventListener('resize', () => { if (dialog.open) syncColourStrips(true); });
      ui('options').addEventListener('change', rememberChoices);
      ui('retry').addEventListener('click', populate);
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); } });
      dialog.addEventListener('keyup', event => { if (event.key === 'Escape') { event.stopPropagation(); close(); } });
      dialog.addEventListener('click', event => { event.stopPropagation(); if (event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close(); } });
      ui('view-bag').addEventListener('click', event => { if (!document.getElementById('CartDrawer') || (editMode && uncertain)) return; event.preventDefault(); close(false); document.dispatchEvent(new CustomEvent('cart:open')); });
      const saveEditedOptions = async () => {
        if (!editingLine || submit.disabled) return;
        submitting = true;
        submit.disabled = true; submit.textContent = copy.saving; submit.setAttribute('aria-busy', 'true');
        ui('close').disabled = true; ui('cancel').disabled = true; ui('options').disabled = true;
        ui('error').hidden = true;
        let updatedCart = null;
        let refreshed = false;
        try {
          updatedCart = await replaceCartLine(editingLine, selectedVariant.id);
          await refreshDrawer(updatedCart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));
          refreshed = true;
        } catch (reason) {
          uncertain = Boolean(reason.needsReview || updatedCart);
          error(updatedCart ? copy.refreshError : reason.message || copy.cartChanged);
          ui('view-bag').hidden = false;
          document.dispatchEvent(new CustomEvent('cart:build'));
        } finally {
          submitting = false;
          ui('close').disabled = false; ui('cancel').disabled = false; ui('options').disabled = false;
          submit.removeAttribute('aria-busy'); submit.textContent = copy.saveChanges; submit.disabled = uncertain;
        }
        if (refreshed) {
          const target = matchingLines(updatedCart, selectedVariant.id)[0];
          close(false);
          returnToDrawer(target?.key);
          document.querySelector('[data-ccp-shopping-status]').textContent = copy.saved;
        }
      };
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (submitting || uncertain || !selectedVariant?.available || !form.reportValidity()) return;
        if (editMode) { await saveEditedOptions(); return; }
        submitting = true;
        submit.disabled = true; submit.textContent = copy.adding; submit.setAttribute('aria-busy', 'true');
        ui('close').disabled = true; ui('options').disabled = true; quantity.disabled = true;
        ui('error').hidden = true;
        const id = selectedVariant.id;
        const amount = Number(quantity.value);
        let added = null;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(root() + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin', signal: controller.signal,
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id, quantity: amount })
          });
          const payload = await response.json();
          if (!response.ok) {
            error(typeof payload.description === 'string' ? payload.description : copy.addError);
          } else { added = payload; }
        } catch {
          uncertain = true; error(copy.uncertain); ui('view-bag').hidden = false;
        } finally {
          clearTimeout(timeout);
          submitting = false; ui('close').disabled = false; ui('options').disabled = false; quantity.disabled = false;
          submit.removeAttribute('aria-busy'); submit.textContent = copy.addLabel; submit.disabled = uncertain;
        }
        if (added) {
          const trigger = activeTrigger;
          close();
          document.querySelector('[data-ccp-shopping-status]').textContent = copy.added;
          if (document.getElementById('CartDrawer')) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added, addToCartBtn: trigger } }));
          } else { location.assign(root() + 'cart'); }
        }
      });
      initializeGalleries();
      document.addEventListener('collection:reloaded', initializeGalleries);
      document.addEventListener('shopify:section:load', initializeGalleries);
      window.addEventListener('pagehide', () => { if (dialog.open && !submitting) close(false); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
    else ready();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ccp-product-polish"] && !Shopify.designMode) return;
  try {
    (() => {
    const cleanups = new WeakMap();

    const initializeProductPolish = (root) => {
      if (root.dataset.modal === 'true' || cleanups.has(root)) return;
      const bar = root.querySelector('[data-ccp-mobile-buybar]');
      const proxyButton = bar?.querySelector('[data-ccp-mobile-add]');
      let formButton = root.querySelector('.product-single__form .add-to-cart');
      const barPrice = bar?.querySelector('[data-ccp-mobile-price]');
      const selection = bar?.querySelector('[data-ccp-mobile-selection]');
      const metadata = root.querySelector('.product-single__meta');
      const nav = root.querySelector('[data-ccp-gallery-nav]');
      const gallery = root.querySelector('[data-product-photos]');
      const observers = [];
      const removers = [];
      let frame = 0;

      if (!bar || !proxyButton || !formButton) return;
      const addLabel = proxyButton.textContent.trim();

      const syncPurchase = () => {
        formButton = root.querySelector('.product-single__form .add-to-cart');
        if (!formButton) {
          bar.hidden = true;
          return;
        }
        const price = root.querySelector('[data-product-price]');
        const buttonPrice = formButton.querySelector('[data-ccp-button-price]');
        const buttonPriceValue = buttonPrice?.querySelector('[data-ccp-button-price-value]');
        if (buttonPrice) {
          buttonPrice.hidden = formButton.disabled;
          const value = price?.textContent.trim();
          if (value && buttonPriceValue && buttonPriceValue.textContent !== value) {
            buttonPriceValue.textContent = value;
          }
        }
        proxyButton.disabled = formButton.disabled;
        const busy = formButton.classList.contains('btn--loading') || formButton.getAttribute('aria-busy') === 'true';
        proxyButton.disabled = formButton.disabled || busy;
        proxyButton.setAttribute('aria-busy', String(busy));
        const label = formButton.disabled ? (formButton.querySelector('[data-add-to-cart-text]') || formButton).textContent.trim() : addLabel;
        if (proxyButton.textContent !== label) proxyButton.textContent = label;
        if (price && barPrice) {
          const value = price.textContent.trim();
          if (barPrice.textContent !== value) barPrice.textContent = value;
          barPrice.classList.toggle('on-sale', price.classList.contains('on-sale'));
        }
        const values = Array.from(root.querySelectorAll('.swatches-type-products [role="radio"][aria-checked="true"]')).map(option => option.getAttribute('aria-label')).filter(Boolean);
        if (!values.length) {
          root.querySelectorAll('.variant-input input:checked').forEach(option => values.push(option.value));
        }
        const chosen = values.join(' · ');
        if (selection && selection.textContent !== chosen) {
          selection.textContent = chosen;
          selection.title = chosen;
        }
        const overlayOpen = document.documentElement.classList.contains('js-drawer-open') || document.documentElement.classList.contains('modal-open') || Boolean(document.querySelector('.pswp--open'));
        const formPassed = formButton.getBoundingClientRect().bottom <= 0;
        bar.hidden = !formPassed || overlayOpen;
      };

      const queuePurchase = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          syncPurchase();
        });
      };

      const addToBag = () => {
        if (!formButton.disabled && !proxyButton.disabled) formButton.click();
      };
      proxyButton.addEventListener('click', addToBag);
      removers.push(() => proxyButton.removeEventListener('click', addToBag));

      const purchaseObserver = new MutationObserver(records => {
        if (records.some(record => !bar.contains(record.target))) queuePurchase();
      });
      purchaseObserver.observe(metadata, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-checked', 'aria-busy'], childList: true, characterData: true, subtree: true });
      observers.push(purchaseObserver);

      const overlayObserver = new MutationObserver(queuePurchase);
      overlayObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      observers.push(overlayObserver);

      window.addEventListener('scroll', queuePurchase, { passive: true });
      window.addEventListener('resize', queuePurchase, { passive: true });
      removers.push(() => window.removeEventListener('scroll', queuePurchase), () => window.removeEventListener('resize', queuePurchase));

      if (gallery && nav) {
        const photos = gallery.closest('.product__main-photos');
        photos.append(nav);
        const counter = nav.querySelector('[data-ccp-gallery-count]');
        const dots = nav.querySelector('[data-ccp-gallery-dots]');
        const previous = nav.querySelector('[data-ccp-gallery-prev]');
        const next = nav.querySelector('[data-ccp-gallery-next]');
        previous.setAttribute('aria-controls', gallery.id);
        next.setAttribute('aria-controls', gallery.id);
        const slides = () => Array.from(gallery.querySelectorAll('.product-main-slide')).filter(slide => !slide.hidden && !slide.classList.contains('hide') && getComputedStyle(slide).display !== 'none');
        let dotSignature = '';
        let selectedDot = '';

        const syncGallery = () => {
          const items = slides();
          const selected = items.findIndex(slide => slide.classList.contains('is-selected'));
          const ready = items.length > 1 && selected >= 0 && Boolean(root.querySelector('[data-product-thumb]'));
          nav.hidden = !ready;
          if (gallery.classList.contains('ccp-gallery-ready') !== ready) gallery.classList.toggle('ccp-gallery-ready', ready);
          if (!ready) return;
          const current = selected + 1;
          const display = counter.dataset.label.replace('[current]', current).replace('[total]', items.length);
          if (counter.textContent !== display) {
            counter.textContent = display;
          }
          const signature = items.map(slide => slide.dataset.index).join(',');
          if (signature !== dotSignature) {
            dotSignature = signature;
            selectedDot = '';
            dots.replaceChildren(...items.map((slide, index) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.dataset.ccpGalleryIndex = slide.dataset.index;
              dot.setAttribute('aria-controls', gallery.id);
              dot.setAttribute('aria-label', counter.dataset.label.replace('[current]', index + 1).replace('[total]', items.length));
              return dot;
            }));
          }
          const activeIndex = items[selected].dataset.index;
          if (selectedDot !== activeIndex) {
            selectedDot = activeIndex;
            Array.from(dots.children).forEach(dot => dot.setAttribute('aria-current', String(dot.dataset.ccpGalleryIndex === activeIndex)));
            const activeDot = dots.children[selected];
            dots.scrollTo({ left: activeDot.offsetLeft - dots.offsetLeft - (dots.clientWidth - activeDot.offsetWidth) / 2, behavior: 'auto' });
          }
          gallery.querySelectorAll('.js-photoswipe__zoom').forEach(button => {
            const label = nav.dataset.zoomLabel;
            if (label && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
          });
        };

        const selectSlide = index => {
          const thumb = Array.from(root.querySelectorAll('[data-product-thumb]')).find(item => item.dataset.index === index);
          thumb?.click();
          syncGallery();
        };
        const move = direction => {
          const items = slides();
          const current = items.findIndex(slide => slide.classList.contains('is-selected'));
          if (current < 0 || items.length < 2) return;
          const target = items[(current + direction + items.length) % items.length];
          selectSlide(target.dataset.index);
        };
        const chooseDot = event => {
          const dot = event.target.closest('[data-ccp-gallery-index]');
          if (dot && dots.contains(dot)) selectSlide(dot.dataset.ccpGalleryIndex);
        };
        const back = () => move(-1);
        const forward = () => move(1);
        dots.addEventListener('click', chooseDot);
        previous.addEventListener('click', back);
        next.addEventListener('click', forward);
        removers.push(() => dots.removeEventListener('click', chooseDot), () => previous.removeEventListener('click', back), () => next.removeEventListener('click', forward));
        const galleryObserver = new MutationObserver(syncGallery);
        galleryObserver.observe(gallery, { attributes: true, attributeFilter: ['class', 'hidden'], childList: true, subtree: true });
        observers.push(galleryObserver);
        syncGallery();
      }

      syncPurchase();
      cleanups.set(root, () => {
        observers.forEach(observer => observer.disconnect());
        removers.forEach(remove => remove());
        cancelAnimationFrame(frame);
        cleanups.delete(root);
      });
    };

    const initializeAll = () => {
      document.querySelectorAll('.product-section').forEach(initializeProductPolish);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('.product-section').forEach(root => cleanups.get(root)?.());
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ccp-search-cards"] && !Shopify.designMode) return;
  try {
    if (document.body.classList.contains('template-search')) {
    const productSearchUrl = new URL(window.location.href);
    if (productSearchUrl.searchParams.get('type') !== 'product') {
      productSearchUrl.searchParams.set('type', 'product');
      productSearchUrl.searchParams.delete('page');
      window.location.replace(productSearchUrl.href);
    }
  }
  } catch(e) { console.error(e); }
})();

})();
